import type { ComponentProps } from 'react';
import { Input } from '../../ui/index.ts';

type InputProps = ComponentProps<typeof Input>;

/** TPM input in millions of tokens, with a mono "M" suffix. */
export function TpmField({
  wrapperClassName = 'w-28',
  ...rest
}: Omit<InputProps, 'mono'>): JSX.Element {
  return (
    <span className="inline-flex items-center gap-1">
      <Input mono wrapperClassName={wrapperClassName} {...rest} />
      <span className="font-mono text-dense text-paper-low">M</span>
    </span>
  );
}
